// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10blV","importantInfo":"styles_importantInfo__2VHyS"};